import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Guides",
  "description": "Learn how to use your favorite tooling in a Turborepo."
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo works with your favorite frameworks, CI providers, tools, and use cases."
  }, {
    "heading": "",
    "content": "In our community-supported guides, you'll find examples of how to use turbo with the rest of your tooling."
  }],
  "headings": []
};
import {Cards, Card} from '#components/card';
export const toc = [];
function _createMdxContent(props) {
  const _components = {
    code: "code",
    p: "p",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "Turborepo works with your favorite frameworks, CI providers, tools, and use cases."
    }), "\n", _jsxs(_components.p, {
      children: ["In our community-supported guides, you'll find examples of how to use ", _jsx(_components.code, {
        children: "turbo"
      }), " with the rest of your tooling."]
    }), "\n", _jsxs(Cards, {
      children: [_jsx(Card, {
        title: "Frameworks",
        description: "Integrate frameworks into your Turborepo",
        href: "/docs/guides/frameworks"
      }), _jsx(Card, {
        title: "Continuous Integration",
        description: "Use Turborepo with your CI",
        href: "/docs/guides/ci-vendors"
      }), _jsx(Card, {
        title: "Tools",
        description: "Bring your favorite tooling",
        href: "/docs/guides/tools"
      }), _jsx(Card, {
        title: "Single-package workspaces",
        description: "Integrate with a standalone application",
        href: "/docs/guides/single-package-workspaces"
      }), _jsx(Card, {
        title: "Generating code",
        description: "Create new code fast",
        href: "/docs/guides/generating-code"
      }), _jsx(Card, {
        title: "Skipping tasks",
        description: "Go fast by doing nothing",
        href: "/docs/guides/skipping-tasks"
      }), _jsx(Card, {
        title: "Publishing packages",
        description: "Use your packages outside of your Turborepo",
        href: "/docs/guides/publishing-libraries"
      }), _jsx(Card, {
        title: "Handling platforms",
        description: "OS, Node.js version, and other factors",
        href: "/docs/guides/handling-platforms"
      }), _jsx(Card, {
        title: "Multi-language support",
        description: "Many languages, one repository",
        href: "/docs/guides/multi-language"
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
